import { assoc, reduce } from "ramda";
import { DocumentExceptions } from "../presenter/types";
import {
  ExceptionValueModels,
  SpreadDocumentExceptions
} from "../spread/types";

export const buildDocumentExceptions = (
  documentExceptions: SpreadDocumentExceptions[]
): DocumentExceptions => {
  return reduce(
    (outteraccum: {}, documentException: SpreadDocumentExceptions) => {
      const { id: exceptionId, caption, disabled, type } = documentException;
      return reduce(
        (inneraccum: {}, exceptionValueModel: ExceptionValueModels) => {
          const valueAsReported = exceptionValueModel.value;
          const hasError = exceptionValueModel.hasError;
          const period = exceptionValueModel.period;
          const pafException = type === "ACCOUNTING_VERIFICATION";
          return hasError && !pafException
            ? assoc(
                exceptionValueModel.financialValueId,
                {
                  exceptionId,
                  caption,
                  disabled,
                  type,
                  period,
                  hasError,
                  valueAsReported
                },
                inneraccum
              )
            : inneraccum;
        },
        outteraccum,
        documentException.firstRow.exceptionValueModels
      );
    },
    {},
    documentExceptions
  );
};



// WEBPACK FOOTER //
// ./src/spread/model/derivedModel/accountDocumentExceptions.ts